export function clearTinyMCEContent(html: string) {
  let tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  let hiddenElements = tempDiv.querySelectorAll('[style*="display: none"]');
  hiddenElements.forEach((el) => el.remove());
  let wscElements = tempDiv.querySelectorAll(".wsc-element");
  wscElements.forEach((el) => el.remove());
  let flyMsgElements = tempDiv.querySelectorAll("fms-fly-app");
  flyMsgElements.forEach((el) => el.remove());

  // Remove trailing empty block elements added by TinyMCE (e.g. <div>&nbsp;</div>, <div><br></div>)
  let lastChild = tempDiv.lastElementChild;
  while (lastChild) {
    const tagName = lastChild.tagName.toLowerCase();
    if ((tagName === 'div' || tagName === 'p') && isEmptyBlock(lastChild)) {
      lastChild.remove();
      lastChild = tempDiv.lastElementChild;
    } else {
      break;
    }
  }

  return tempDiv.innerHTML.trim();
}

function isEmptyBlock(el: Element): boolean {
  // \u00a0 is the decoded form of &nbsp;
  const text = el.textContent?.replace(/\u00a0/g, '').trim();
  if (!text) {
    if (el.children.length === 0) return true;
    for (let i = 0; i < el.children.length; i++) {
      if (el.children[i].tagName.toLowerCase() !== 'br') return false;
    }
    return true;
  }
  return false;
}
